import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../components/Form/Field'

import {
  AGE_PERCENTAGE,
  ageFields,
  ageFieldLabels,
  activityLevelFields,
  STAKEHOLDERS_LIST
} from '../../../../../../stakeholdersFields'

import useStyles from '../styles'

const AgeDistributionWithActivityLevels = ({ formik, index }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const path = `${STAKEHOLDERS_LIST}[${index}][${AGE_PERCENTAGE}]`

  return (
    <FieldLabelWrapper label={t('Age Distribution & Activity Levels')}>
      {/* Header row */}
      <div className={classnames(classes.row, classes.ageActivityHeaderRow)}>
        <FieldLabelWrapper
          label={t('Total %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
        <FieldLabelWrapper
          label={t('Inactive %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
        <FieldLabelWrapper
          label={t('Less Active %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
        <FieldLabelWrapper
          label={t('Fairly Active %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
        <FieldLabelWrapper
          label={t('Active %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
        <FieldLabelWrapper
          label={t('Unknown %')}
          className={classes.subLevelFieldWrapper}
          labelClassName={classes.subLevelLabel}
        />
      </div>

      {/* Data rows */}
      {Object.values(ageFields).map(ageField => (
        <FieldLabelWrapper key={ageField} label={t(ageFieldLabels[ageField])} className={classes.ageGroupFieldWrapper}>
          <div className={classnames(classes.row, classes.ageActivityRow)}>
            <FieldLabelWrapper className={classes.subLevelFieldWrapper}>
              <Field
                className={classes.fieldInRow}
                formik={formik}
                name={`${path}[${ageField}][total]`}
                symbol="%"
                symbolPosition="end"
                type="number"
              />
            </FieldLabelWrapper>
            {Object.values(activityLevelFields).map(activityField => (
              <FieldLabelWrapper key={activityField} className={classes.subLevelFieldWrapper}>
                <Field
                  className={classes.fieldInRow}
                  formik={formik}
                  name={`${path}[${ageField}][${activityField}]`}
                  symbol="%"
                  symbolPosition="end"
                  type="number"
                />
              </FieldLabelWrapper>
            ))}
          </div>
        </FieldLabelWrapper>
      ))}
    </FieldLabelWrapper>
  )
}

AgeDistributionWithActivityLevels.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default AgeDistributionWithActivityLevels
